import React from 'react';

const BADGE_CLASS =
  'pointer-events-none absolute -right-1 -top-1 z-10 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-white px-1 text-[10px] font-bold leading-none text-[#5C3BD1] shadow-sm';

export default function NavPendingBadge({ count, testId }) {
  if (!count) return null;

  return (
    <span data-testid={testId} aria-hidden="true" className={BADGE_CLASS}>
      {count}
    </span>
  );
}
